export enum IDME_COOKIES {
  IDME_USER_DETAILS = 'IDME_USER_DETAILS',
}
